/* ----------------- React Native Paper --------------- */
import Icon from "@react-native-vector-icons/material-design-icons/static";
import { Card } from "react-native-paper";

import type { IconType } from "../../../icon";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";
import Button from "../../Button";
import { CardIconHeader } from "../CardIconHeader";
import { FlatCard } from "../FlatCard";

/* ----------------- Components --------------- */
import CardContent, { type MasteryListItemProps } from "./CardContent";

export type StudySessionMasteryTagProgressCardProps = {
	title: string;
	subtitle: string;
	items: MasteryListItemProps[];
	handleClickCard?: () => void;
	cta?: string;
	icon?: IconType;
	tooltip?: string;
	tagType?: string;
	handleClickInfo?: (text: string) => void;
	showViewAll?: boolean;
	actionsBelow?: boolean;
};
export const StudySessionMasteryTagProgressCard = ({
	title,
	subtitle,
	items,
	handleClickCard,
	cta,
	tooltip,
	tagType,
	handleClickInfo,
	showViewAll = false,
	actionsBelow,
	icon,
}: StudySessionMasteryTagProgressCardProps) => {
	const theme = useAppTheme();
	const resolvedIcon: IconType = icon ?? "layers-outline";
	const shouldShowViewAll =
		showViewAll || ((cta || handleClickCard) && items.length > 3);
	const finalItems = items.slice(0, 4);

	const ActionsCard = () => {
		if (shouldShowViewAll) {
			return (
				<Card.Actions>
					<Button mode="text" onPress={handleClickCard}>
						{cta || "View topics"}
					</Button>
				</Card.Actions>
			);
		}
		return null;
	};

	return (
		<FlatCard>
			<Box paddingHorizontal={16} paddingTop={16} gap={4}>
				<Box flexDirection="row" alignItems="center" gap={8}>
					<CardIconHeader
						icon={resolvedIcon}
						title={title}
						subtitle={subtitle}
					/>
					{tooltip && handleClickInfo ? (
						<Icon
							name="information-outline"
							size={16}
							color={theme.colors.onSurfaceVariant}
							onPress={() => handleClickInfo(tooltip)}
							accessibilityRole="button"
							accessibilityLabel="information"
						/>
					) : null}
				</Box>
			</Box>
			<CardContent
				items={finalItems}
				tagType={tagType}
				actionsBelow={actionsBelow}
			/>
			<ActionsCard />
		</FlatCard>
	);
};
